export default () => ({
  root: {},
  wrapper: {
    minHeight: 'calc(100vh - 100px)',
  }
});